import { render, staticRenderFns } from "./FormContratcreate.vue?vue&type=template&id=0277cca2&"
import script from "./FormContratcreate.vue?vue&type=script&lang=js&"
export * from "./FormContratcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports